export default __webpack_public_path__ + "static/media/min7.2fcc4404.JPG";